"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var EyeClosed = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_EyeClosed_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 4,
    width: 17,
    height: 8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.063 4.712C-.119 4.385.128 4 .503 4c.192 0 .368.108.463.276a8.081 8.081 0 0 0 7.037 4.068 8.082 8.082 0 0 0 7.036-4.068.537.537 0 0 1 .464-.276c.374 0 .621.385.439.712a9.031 9.031 0 0 1-1.95 2.396l1.628 1.64a.625.625 0 1 1-.887.88L13.057 7.94a.63.63 0 0 1-.064-.076A9.075 9.075 0 0 1 10.77 8.92a.59.59 0 0 1 .016.035l.884 2.186a.625.625 0 1 1-1.159.468l-.884-2.186a.624.624 0 0 1-.046-.213 9.214 9.214 0 0 1-3.172-.003.624.624 0 0 1-.046.216L5.48 11.61a.625.625 0 0 1-1.159-.47l.885-2.185a.638.638 0 0 1 .017-.04A9.076 9.076 0 0 1 3.01 7.863a.63.63 0 0 1-.067.079L1.255 9.63a.625.625 0 1 1-.884-.884l1.64-1.64A9.032 9.032 0 0 1 .063 4.712Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_EyeClosed_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = EyeClosed;
exports["default"] = _default;